import { useNodeDynamicPropertiesProps, useQueryNodeDynamicProperties } from "./useQueryNodeDynamicProperties"
import { UseQueryResult } from "@tanstack/react-query"
import { ComboboxOption } from "@/components/ui/combobox"

interface useQueryDynamicOptionsProps extends useNodeDynamicPropertiesProps {
    property_id?: string
}

export function useQueryDynamicOptions(props: useQueryDynamicOptionsProps) {
    const queryResult = useQueryNodeDynamicProperties({
        ...props,
        enabled: !!props.enabled && !!props.property_id,
        endpointPath: "dynamic-options",
        property_id: props.property_id,
    })

    return queryResult as unknown as UseQueryResult<{
        options: ComboboxOption[];
    }, Error>
}